import React from 'react';
import PageHeader from '../components/ui/PageHeader';
import AboutIntro from '../components/sections/AboutIntro';
import TeamPerformance from '../components/sections/TeamPerformance';
import StatsSection from '../components/sections/StatsSection'; // Reused from Home Page!
import PreFooterCta from '../components/sections/PreFooterCta'; // Reused!

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-royal-navy">
      {/* 1. Page Header */}
      <PageHeader title="About Us" />
      
      {/* 2. Vision and Mission */}
      <AboutIntro />

      {/* 3. Performance Progress Bars */}
      <TeamPerformance />

      {/* 4. Stats Counter (100% Satisfaction, etc.) */}
      <div className="bg-[#1A1F29]/30 border-y border-white/5 pb-10">
        <div className="text-center pt-20 pb-4">
            <h2 className="text-3xl font-bold text-white mb-4">Best Growing Agency</h2>
            <p className="text-gray-400 max-w-2xl mx-auto">
                Our team of experts is dedicated to delivering innovative IT solutions that help businesses thrive.
            </p>
        </div>
        <StatsSection />
      </div>

      {/* 5. Pre-Footer Contact Block */}
      <PreFooterCta />
    </div>
  );
};

export default AboutPage;